import React from "react";
import { withRouter } from "react-router-dom";
import TypeTile from "components/TypeTile";
import { connect } from "react-redux";
import { removeHtmlTags } from "utils/utils";
import {
  getSurveys,
  getResponses,
  getTopics,
  getUser,
  getSurveyExport,
  setPageTitle,
  updateResponse,
} from "redux/actions";
import { parseQuery } from "utils/utils";
import { stringifyQuery, isTextTypeStrict } from "utils/utils";
import QuestionAnalytics from "./QuestionAnalytics";
import ResponseTable from "./ResponseTable";
import { Tooltip, Menu, MenuItem } from "@material-ui/core";
import { isAudioType, isVideoType, getStimuliJSX } from "utils/utils";
import EditSentimentPopup from "components/Popups/EditSentimentPopup";
import AddToShowreelPopup from "components/Popups/AddToShowreelPopup";
import AddToReportPopup from "components/Popups/AddToReportPopup";
import { isAudioOrVideoType } from "utils/utils";
import TopicsView from "./TopicsView";
import { isEqual } from "lodash";
import ResponseViewPopup from "components/Popups/ResponseViewPopup.jsx";
import { hasPlayScreen } from "utils/utils";

const getResponseMap = (state, ownProps) => {
  var s = {};
  if (state.responses) {
    s.responses = state.responses[ownProps.match.params.questionId];
  }
  if (state.topics) {
    s.topics = state.topics[ownProps.match.params.questionId];
  }
  if (state.urlParams) {
    s.urlParams = state.urlParams[ownProps.match.params.questionId];
  }
  if (state.topics) {
    s.topics = state.topics[ownProps.match.params.questionId];
  }
  return s;
};

const mapStateToProps = (state, ownProps) => {
  return {
    ...getResponseMap(state, ownProps),
    searchText: state.searchText,
    loading: state.loading["Question"],
    exportLoading: state.loading["SurveyExport"],
    topicsDirtied: state.topicsDirtied,
  };
};
const mapDispatchToProps = {
  getSurveys,
  getResponses,
  getTopics,
  getUser,
  getSurveyExport,
  setPageTitle,
  updateResponse,
};

class Question extends React.Component {
  state = {
    filters: {
      processedMedia: false,
      emotions: new Set([]),
      bookmarked: false,
      word: "",
      sentiment: undefined,
    },
    displayOptions: {
      demographics: true,
      externalId: false,
      public: false,
    },
    showTopics: false,
    currentResponse: null,
    responsePopupOpen: false,
    sentimentPopupOpen: false,
    reportPopupOpen: false,
    showreelsPopupOpen: false,
  };

  componentDidMount() {
    this.fetchResponses();
    this.props.getTopics(this.props.match.params.questionId);
    document.addEventListener("keydown", this.handleKeyStroke, false);
  }

  componentDidUpdate(prevProps, prevState) {
    // If query parameters are changed (with the exception of "page") refresh responses
    const prevQuery = parseQuery(prevProps.location.search);
    delete prevQuery.page;
    const query = parseQuery(this.props.location.search);
    delete query.page;
    if (
      prevProps.match.params.questionId !==
        this.props.match.params.questionId ||
      !isEqual(prevQuery, query) ||
      (!prevProps.topicsDirtied && this.props.topicsDirtied)
    ) {
      this.fetchResponses();
      this.props.getTopics(this.props.match.params.questionId);
    }
  }

  handleKeyStroke = (event) => {
    if (!this.state.responsePopupOpen) {
      return;
    } else if (event.keyCode === 37) {
      this.prevResponse();
    } else if (event.keyCode === 39) {
      this.nextResponse();
    }
  };

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyStroke, false);
  }

  fetchResponses = () => {
    const query = parseQuery(this.props.location.search);
    delete query.page;
    query.include_metadata = "true";
    this.props.getResponses(
      this.props.match.params.surveyId,
      this.props.match.params.questionId,
      `?${stringifyQuery(query)}`
    );
  };

  filterAndSort = (responses) => {
    if (responses === undefined) return responses;
    // Search Text
    if (this.props.filters.searchText)
      responses = responses.filter(
        (r) =>
          (r.features &&
            r.features.transcription &&
            r.features.transcription
              .toLowerCase()
              .includes(this.props.filters.searchText.toLowerCase())) ||
          (isTextTypeStrict(r.type) &&
            r.data &&
            r.data
              .toLowerCase()
              .includes(this.props.filters.searchText.toLowerCase()))
      );

    if (this.props.filters.emotions.size > 0) {
      // Emotion Stuff
      responses = responses.filter((r) => {
        if (!r.features || !r.features.emotions) return false;
        let collision = 0;
        r.features.emotions.emojis.split(" ").forEach((e) => {
          if (this.props.filters.emotions.has(e)) collision += 1;
        });
        return collision === this.props.filters.emotions.size;
      });
    }
    // Processed Media
    if (
      this.props.filters.processedMedia &&
      this.props.question.doTranscription &&
      (isAudioType(this.props.question.type) ||
        isVideoType(this.props.question.type))
    ) {
      responses = responses.filter((r) => {
        return (
          (r.features &&
            r.features.transcription &&
            r.features.transcription !== "Processing...") ||
          r.backupText
        );
      });
    }
    // Bookmarked Responses
    if (this.props.filters.bookmarked) {
      responses = responses.filter((r) => {
        return r.bookmarked === true;
      });
    }
    // Filter Sentiment via pie chart
    if (this.props.filters.sentiment) {
      responses = responses.filter((r) => {
        return (
          (r.features && r.features.sentiment) ===
          this.props.filters.sentiment.toUpperCase()
        );
      });
    }
    // Filter Word via word cloud
    if (this.props.filters.word) {
      responses = responses.filter((r) => {
        const text = (r.features && r.features.transcription) || r.backupText;
        if (!text) return false;
        return text.indexOf(this.props.filters.word) !== -1;
      });
    }
    // Filter by date
    if (this.props.filters.startDate) {
      responses = responses.filter((r) => {
        let resDate = new Date(r.createdAt + "Z");
        let startDateObj = new Date(this.props.filters.startDate + "Z");
        return resDate.valueOf() > startDateObj.valueOf();
      });
    }

    if (this.props.filters.completionStatus) {
      responses = responses.filter((r) => {
        var flag =
          this.props.sessions.find((s) => s.sessionId === r.sessionId).features
            .completionStatus === this.props.filters.completionStatus;
        return flag;
      });
    }

    return responses;
  };

  toggleTopics = () => {
    this.setState({ showTopics: !this.state.showTopics });
  };

  nextResponse = () => {
    var filteredResponses = this.filterAndSort(this.props.responses);
    var filteredIdx = filteredResponses.findIndex(
      (session) => session === this.state.currentResponse
    );
    var nextResp =
      filteredIdx < filteredResponses.length - 1
        ? filteredResponses[filteredIdx + 1]
        : filteredResponses[0];
    this.setState({
      responsePopupOpen: true,
      currentResponse: nextResp,
    });
  };

  prevResponse = () => {
    var filteredResponses = this.filterAndSort(this.props.responses);
    var filteredIdx = filteredResponses.findIndex(
      (session) => session === this.state.currentResponse
    );
    var prevResp =
      filteredIdx > 0
        ? filteredResponses[filteredIdx - 1]
        : filteredResponses[filteredResponses.length - 1];
    this.setState({
      responsePopupOpen: true,
      currentResponse: prevResp,
    });
  };

  openResponse = (res) => {
    if (hasPlayScreen(res)) {
      this.setState({
        responsePopupOpen: true,
        currentResponse: this.props.responses.find((s) => s._id === res._id),
      });
    }
  };

  /**
   * Utility functions for response popups
   */
  closeResponsePopup = () => {
    this.setState({
      sentimentPopupOpen: false,
      showreelsPopupOpen: false,
      reportPopupOpen: false,
      modelPickerOpen: false,
      responsePopupOpen: false,
      responseMenuResponse: undefined,
      responseMenuAnchorEl: undefined,
      currentResponse: null,
    });
  };

  openReportsPopup = (blockInfo) => {
    this.setState({
      reportPopupOpen: true,
      reportPopupBlockInfo: blockInfo,
    });
  };
  openShowreelsPopup = (response) => {
    this.setState({
      showreelsPopupOpen: true,
      showreelsPopupResponse: response,
    });
  };
  openResponseMenu = (e, response) => {
    this.setState({
      responseMenuAnchorEl: e.currentTarget,
      responseMenuResponse: response,
    });
  };
  getRandomResponse = () => {
    if (!this.props.responses || this.props.responses.length === 0) return;

    // Keep rerolling until we find some real data. Only retry a few times
    let retries = 10;
    let text = "";
    while (text === "" && retries > 0) {
      const response =
        this.props.responses[
          Math.floor(Math.random() * this.props.responses.length)
        ];
      if (response.features && response.features.transcription) {
        text = response.features.transcription;
      } else if (response.backupText) {
        text = response.backupText;
      } else if (response.data && typeof response.data == "string") {
        text = response.data;
      }
      retries--;
    }
    return text;
  };

  render() {
    if (!this.props.survey || !this.props.question) return null;
    const responses = this.filterAndSort(this.props.responses);
    return (
      <div id="question-pane">
        {/* Popup for viewing a specific response to a question*/}
        <ResponseViewPopup
          open={this.state.responsePopupOpen}
          response={this.state.currentResponse}
          prevResponse={this.prevResponse}
          nextResponse={this.nextResponse}
          onClose={this.closeResponsePopup}
          updateResponse={(id, update) => {
            this.props.updateResponse(id, update).then(() => {
              this.fetchResponses();
            });
          }}
          user={this.props.user}
          style={{ height: "90%" }}
        />
        {/* Popups for adding to showreels, reports, and editing sentiment */}
        <EditSentimentPopup
          open={this.state.sentimentPopupOpen}
          onClose={this.closeResponsePopup}
          response={this.state.responseMenuResponse}
        />
        <AddToReportPopup
          open={this.state.reportPopupOpen}
          onClose={this.closeResponsePopup}
          blockInfo={this.state.reportPopupBlockInfo}
        />
        <AddToShowreelPopup
          open={this.state.showreelsPopupOpen}
          onClose={this.closeResponsePopup}
          response={this.state.showreelsPopupResponse}
        />

        {/* Popover showing response options */}
        <Menu
          anchorEl={this.state.responseMenuAnchorEl}
          open={Boolean(this.state.responseMenuAnchorEl)}
          onClose={this.closeResponsePopup}
        >
          <MenuItem
            onClick={() => {
              this.openReportsPopup({
                type: "RESPONSE",
                responseId: this.state.responseMenuResponse._id,
              });
            }}
          >
            Add to Report
          </MenuItem>
          {this.state.responseMenuResponse &&
            (this.state.responseMenuResponse.audioPath ||
              this.state.responseMenuResponse.videoPath) && (
              <MenuItem
                onClick={() => {
                  this.openShowreelsPopup(this.state.responseMenuResponse);
                }}
              >
                Add to Showreel
              </MenuItem>
            )}
          {this.props.question &&
            isAudioOrVideoType(this.props.question.type) &&
            this.props.question.doSentiment && (
              <MenuItem
                onClick={() => this.setState({ sentimentPopupOpen: true })}
              >
                Edit Sentiment
              </MenuItem>
            )}
        </Menu>
        <div id="title-block">
          <div className="mr-10">
            <TypeTile type={this.props.question.type} shape="square" />
          </div>
          <div className="title-block-text">
            <Tooltip
              title={removeHtmlTags(this.props.question.text)}
              placement="bottom-start"
            >
              <div className="question-title overflow-ellipsis">
                {removeHtmlTags(this.props.question.text)}
              </div>
            </Tooltip>
            <Tooltip
              title={
                removeHtmlTags(this.props.question.subText)
                  ? removeHtmlTags(this.props.question.subText)
                  : ""
              }
              placement="bottom-start"
            >
              <div className="question-subtitle overflow-ellipsis">
                {removeHtmlTags(this.props.question.subText)}
              </div>
            </Tooltip>
            {getStimuliJSX(this.props.question)}
          </div>
        </div>
        <QuestionAnalytics
          survey={this.props.survey}
          question={this.props.question}
          responses={responses}
          topics={this.props.topics}
          updateFilters={this.props.updateFilters}
          closeResponsePopup={this.closeResponsePopup}
          openReportsPopup={this.openReportsPopup}
          entities={this.props.topics}
        />
        {this.state.showTopics ? (
          <TopicsView
            entities={this.props.topics}
            question={this.props.question}
            toggleTopics={this.toggleTopics}
            getRandomResponse={this.getRandomResponse}
          />
        ) : (
          <ResponseTable
            responses={responses}
            question={this.props.question}
            survey={this.props.survey}
            displayOptions={this.props.displayOptions}
            filters={this.props.filters}
            closeResponsePopup={this.closeResponsePopup}
            entities={this.props.topics}
            openReportsPopup={this.openReportsPopup}
            openShowreelsPopup={this.openShowreelsPopup}
            openResponseMenu={this.openResponseMenu}
            toggleTopics={this.toggleTopics}
            updateFilters={this.props.updateFilters}
            loading={this.props.loading}
            searchParams={this.props.searchParams}
            openResponse={this.openResponse}
          />
        )}
      </div>
    );
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Question)
);
